import { LogicTabCombinedProps } from './types';

const usePresenter = (props: LogicTabCombinedProps): LogicTabCombinedProps => {
  return props;
};

export default usePresenter;
